import { render, staticRenderFns } from "./bandstafftwo.vue?vue&type=template&id=23793686&scoped=true"
import script from "./bandstafftwo.vue?vue&type=script&lang=js"
export * from "./bandstafftwo.vue?vue&type=script&lang=js"
import style0 from "./bandstafftwo.vue?vue&type=style&index=0&id=23793686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23793686",
  null
  
)

export default component.exports